import { useEffect, useState } from 'react'
import { HomeHeroBanner } from '../components/HomeHeroBanner'
import { HeroSection } from '../components/HeroSection'
import { InitiativesSection } from '../components/InitiativesSection'
import { ServicesSection } from '../components/ServicesSection'
import { HashtagBannerSection } from '../components/HashtagBannerSection'
import { PhotoshootBannerSection } from '../components/PhotoshootBannerSection'
import { QuoteBannerSection } from '../components/QuoteBannerSection'
import { FeaturedOnSection } from '../components/FeaturedOnSection'
import { JoinAndFollowSection } from '../components/JoinAndFollowSection'
import { TestimonialsCarousel } from '@/features/testimonials'
import { publicService } from '../services/public.service'
import type { FilmDocument } from '@/types'

export function HomePage() {
  const [latestFilm, setLatestFilm] = useState<(FilmDocument & { id: string }) | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    publicService
      .getLatestFilm()
      .then(setLatestFilm)
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [])

  return (
    <div>
      <HomeHeroBanner />
      <HeroSection latestFilm={latestFilm} loading={loading} />
      <QuoteBannerSection />
      <InitiativesSection />
      <HashtagBannerSection />
      <ServicesSection />
      <TestimonialsCarousel />
      <FeaturedOnSection />
      <PhotoshootBannerSection />
      <JoinAndFollowSection />
    </div>
  )
}
